import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FBPostsComponent } from './fb-posts.component';
import { AuthenticatedGuard } from '../shared/guards/authenticated.guard';


export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: FBPostsComponent
    //,canActivate: [AuthenticatedGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class FBPostsRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/facebook-posts/fb-posts-routing.module.ts